import { render, staticRenderFns } from "./UpdatePlatformCoupon.vue?vue&type=template&id=00e10578&"
import script from "./UpdatePlatformCoupon.vue?vue&type=script&lang=js&"
export * from "./UpdatePlatformCoupon.vue?vue&type=script&lang=js&"
import style0 from "./UpdatePlatformCoupon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports